export default "__VITE_ASSET__BpCG6aet__"